import { V6Client } from "@aws-amplify/api-graphql";
import { OnsiteOpsConfig } from "~/api/API";
import { listOnsiteOpsConfigsOptimized } from "~/api/graphql-custom/queries";

export const fetchAllOnsiteOpsConfigs = async (
  client: V6Client,
): Promise<OnsiteOpsConfig[]> => {
  const fetchPage = async (
    nextToken?: string,
    accumulatedItems: OnsiteOpsConfig[] = [],
  ): Promise<OnsiteOpsConfig[]> => {
    const response = await client.graphql({
      query: listOnsiteOpsConfigsOptimized,
      variables: {
        limit: 1000,
        nextToken,
      },
    });

    if (response.errors) {
      throw new Error(
        `Failed to fetch onsite ops configs: ${response.errors.toString()}`,
      );
    }

    const newItems = (response.data?.listOnsiteOpsConfigs?.items || []).filter(
      (item): item is OnsiteOpsConfig => item !== null,
    );
    const combinedItems = [...accumulatedItems, ...newItems];

    if (response.data?.listOnsiteOpsConfigs?.nextToken) {
      return await fetchPage(
        response.data.listOnsiteOpsConfigs.nextToken,
        combinedItems,
      );
    } else {
      return combinedItems;
    }
  };

  return await fetchPage();
};
